import React from 'react';
const MessageIcon = ({ fill, width, height }) => (
    <svg className="icon icon-message" width={width} height={height} viewBox="0 0 20 20">
        <path
            fill={fill}
            d="M10 2c5.701 0 10 3.59 10 8.351 0 4.76-4.299 8.35-10 8.35l-.279-.006-.288-.014-4.853 3.268c-.05.034-.108.051-.167.051-.049 0-.098-.012-.143-.037-.098-.054-.16-.159-.16-.272v-4.395C1.458 15.89 0 13.432 0 10.35 0 5.59 4.299 2 10 2zm0 1.5c-4.927 0-8.5 2.984-8.5 6.851 0 2.435 1.07 4.33 3.076 5.489l.236.13.798.422v3.054l3.4-2.289.785.04.205.005c4.926 0 8.5-2.984 8.5-6.85C18.5 6.483 14.927 3.5 10 3.5zM5 9c.828 0 1.5.672 1.5 1.5S5.828 12 5 12s-1.5-.672-1.5-1.5S4.172 9 5 9zm5 0c.828 0 1.5.672 1.5 1.5S10.828 12 10 12s-1.5-.672-1.5-1.5S9.172 9 10 9zm5 0c.828 0 1.5.672 1.5 1.5S15.828 12 15 12s-1.5-.672-1.5-1.5S14.172 9 15 9z"
            transform="translate(-30 -867) translate(0 315) translate(20) translate(0 540) translate(10 10)"
        />
    </svg>
);

export default MessageIcon;
